import React, { useState } from 'react'
import { Input } from '../../../components'
import { Modal } from 'antd'

const AddGroup = ({ active, onCancel, onOk }) => {

  let [name, setName] = useState('')
  let [error, setError] = useState(false)
  let submit = () => {
    if (name) {
      onOk(name)

      setName('')
      setError(false)
    } else {
      setError(true)
    }
  }
  return (
    <Modal
      title="Add new group"
      visible={active}
      onCancel={onCancel}
      closable={false}
      width={410}
      footer={[
        <button key="submit" className={'btn btn-secondary dart-btn'} style={{ width: 125 }} onClick={submit}>
          Ok
        </button>,
        <button key="back" className={'btn btn-outline-secondary dart-btn-outline'} style={{ width: 125 }}
                onClick={onCancel}>Cancel</button>
      ]}
    >

      <Input type={'text'} value={name} onChange={setName} label={'Name'}
             id={'modalNewTypeName'}/>
      {error && <p className={'text-danger'}>
        Please provide a name.
      </p>}

    </Modal>
  )
}

export default AddGroup